import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMap"><Path d="M2 5.52946L8 3.52946V18.6376L2 20.6376V5.52946Z" fill="currentColor"/><Path d="M14 19.971L10 18.6376V3.52946L14 4.86279V19.971Z" fill="currentColor"/><Path d="M16 19.971L22 17.971V2.86279L16 4.86279V19.971Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMap;
